/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { EnvironmentStatus } from "~/models";

export const envStatusOptions = [
  { label: "Not in Scope", value: EnvironmentStatus.NOT_IN_SCOPE },
  { label: "Onboarding", value: EnvironmentStatus.ONBOARDING },
  { label: "Live", value: EnvironmentStatus.LIVE },
  { label: "Offboarding", value: EnvironmentStatus.OFFBOARDING },
  { label: "Termination", value: EnvironmentStatus.TERMINATION },
];
